// ============================================================================
// languages.js — REGJISTRI QENDROR I GJUHËVE + logjika e zgjidhjes së gjuhës.
//
// QËLLIMI: sistem FLEKSIBËL menaxhimi gjuhësh, jo funksion i lidhur me një listë
// fikse. Shtimi i një gjuhe të re kërkon VETËM:
//   1) një rresht te LANGUAGES (metadata: kodi, emrat, rajoni),
//   2) skedarin `locales/<kod>.json`,
//   3) aktivizimin nga Admin Center.
// Asnjë ndryshim strukture, asnjë import i ri, asnjë prekje e komponentëve.
//
// NDARJA E PËRGJEGJËSIVE (thelbi i fleksibilitetit):
//   REGJISTRI (ky skedar) = cilat gjuhë EKZISTOJNË si mundësi (vetëm metadata).
//   locales/*.json        = cilat gjuhë kanë vërtet PËRKTHIME.
//   Konfigurimi i Adminit = cilat gjuhë janë AKTIVE për përdoruesit.
// Një gjuhë del te switch-i vetëm kur i plotëson të TRIA. Prandaj regjistri
// mund të përmbajë 72 gjuhë pa detyruar që të gjitha të jenë të përkthyera.
//
// MODELI I PËRKTHIMIT:
//   sq = gjuha BURIM (çelësi ËSHTË teksti shqip; sq.json është identik).
//   en = e punuar me dorë — gjuha PIVOT nga e cila gjenerohen të tjerat.
//   të tjerat = përkthim profesional NGA anglishtja.
// Rruga rezervë: <gjuhë> → en → çelësi (shqip). Asgjë s'mbetet bosh kurrë.
//
// SHËNIM PËR KODET: shumica janë ISO 639-1 (dy shkronja). Katër raste s'kanë
// kod 639-1 dhe përdorin standardin e duhur:
//   cnr (malazezisht, 639-3), fil (filipinisht, 639-2), haw (havajisht, 639-3),
//   zh-Hans / zh-Hant (kinezishtja ndahet me shkrim, jo me gjuhë).
// Aliaset më poshtë kapin variantet që dërgon telefoni (nb-NO → no, zh-TW →
// zh-Hant, sr-ME → cnr, iw → he, in → id).
// ============================================================================

// Rajonet — përdoren për t'i grupuar gjuhët te Admin Center.
export const REGIONS = {
  europe:    { key: "europe",    sq: "Evropë",                    en: "Europe" },
  mena_asia: { key: "mena_asia", sq: "Lindja e Mesme & Azia",     en: "Middle East & Asia" },
  east_asia: { key: "east_asia", sq: "Azia Lindore & Juglindore", en: "East & Southeast Asia" },
  africa:    { key: "africa",    sq: "Afrikë",                    en: "Africa" },
  americas:  { key: "americas",  sq: "Amerika",                   en: "Americas" },
  oceania:   { key: "oceania",   sq: "Oqeani",                    en: "Oceania" },
};
export const REGION_ORDER = ["europe", "mena_asia", "east_asia", "africa", "americas", "oceania"];

// `dir: "rtl"` → shkrim nga e djathta në të majtë (arabisht, hebraisht, persisht,
// urdu, pashto). Trajtohet automatikisht te i18n.js (atributi `dir` i <html>).
export const LANGUAGES = {
  // --- Evropë --------------------------------------------------------------
  sq:  { code: "sq",  native: "Shqip",          en: "Albanian",      sq: "Shqip",          region: "europe" },
  en:  { code: "en",  native: "English",        en: "English",       sq: "Anglisht",       region: "europe" },
  bs:  { code: "bs",  native: "Bosanski",       en: "Bosnian",       sq: "Boshnjakisht",   region: "europe" },
  bg:  { code: "bg",  native: "Български",      en: "Bulgarian",     sq: "Bullgarisht",    region: "europe" },
  cs:  { code: "cs",  native: "Čeština",        en: "Czech",         sq: "Çekisht",        region: "europe" },
  da:  { code: "da",  native: "Dansk",          en: "Danish",        sq: "Danisht",        region: "europe" },
  et:  { code: "et",  native: "Eesti",          en: "Estonian",      sq: "Estonisht",      region: "europe" },
  fi:  { code: "fi",  native: "Suomi",          en: "Finnish",       sq: "Finlandisht",    region: "europe" },
  fr:  { code: "fr",  native: "Français",       en: "French",        sq: "Frëngjisht",     region: "europe" },
  de:  { code: "de",  native: "Deutsch",        en: "German",        sq: "Gjermanisht",    region: "europe" },
  el:  { code: "el",  native: "Ελληνικά",       en: "Greek",         sq: "Greqisht",       region: "europe" },
  nl:  { code: "nl",  native: "Nederlands",     en: "Dutch",         sq: "Holandisht",     region: "europe" },
  hu:  { code: "hu",  native: "Magyar",         en: "Hungarian",     sq: "Hungarisht",     region: "europe" },
  is:  { code: "is",  native: "Íslenska",       en: "Icelandic",     sq: "Islandisht",     region: "europe" },
  ga:  { code: "ga",  native: "Gaeilge",        en: "Irish",         sq: "Irlandisht",     region: "europe" },
  it:  { code: "it",  native: "Italiano",       en: "Italian",       sq: "Italisht",       region: "europe" },
  ca:  { code: "ca",  native: "Català",         en: "Catalan",       sq: "Katalanisht",    region: "europe" },
  hr:  { code: "hr",  native: "Hrvatski",       en: "Croatian",      sq: "Kroatisht",      region: "europe" },
  lv:  { code: "lv",  native: "Latviešu",       en: "Latvian",       sq: "Letonisht",      region: "europe" },
  lt:  { code: "lt",  native: "Lietuvių",       en: "Lithuanian",    sq: "Lituanisht",     region: "europe" },
  lb:  { code: "lb",  native: "Lëtzebuergesch", en: "Luxembourgish", sq: "Luksemburgisht", region: "europe" },
  cnr: { code: "cnr", native: "Crnogorski",     en: "Montenegrin",   sq: "Malazezisht",    region: "europe", aliases: ["sr-me", "me"] },
  mk:  { code: "mk",  native: "Македонски",     en: "Macedonian",    sq: "Maqedonisht",    region: "europe" },
  mt:  { code: "mt",  native: "Malti",          en: "Maltese",       sq: "Maltisht",       region: "europe" },
  no:  { code: "no",  native: "Norsk",          en: "Norwegian",     sq: "Norvegjisht",    region: "europe", aliases: ["nb", "nn"] },
  pl:  { code: "pl",  native: "Polski",         en: "Polish",        sq: "Polonisht",      region: "europe" },
  pt:  { code: "pt",  native: "Português",      en: "Portuguese",    sq: "Portugalisht",   region: "europe" },
  ro:  { code: "ro",  native: "Română",         en: "Romanian",      sq: "Rumanisht",      region: "europe" },
  ru:  { code: "ru",  native: "Русский",        en: "Russian",       sq: "Rusisht",        region: "europe" },
  sr:  { code: "sr",  native: "Српски",         en: "Serbian",       sq: "Serbisht",       region: "europe" },
  sk:  { code: "sk",  native: "Slovenčina",     en: "Slovak",        sq: "Sllovakisht",    region: "europe" },
  sl:  { code: "sl",  native: "Slovenščina",    en: "Slovenian",     sq: "Sllovenisht",    region: "europe" },
  es:  { code: "es",  native: "Español",        en: "Spanish",       sq: "Spanjisht",      region: "europe" },
  sv:  { code: "sv",  native: "Svenska",        en: "Swedish",       sq: "Suedisht",       region: "europe" },
  tr:  { code: "tr",  native: "Türkçe",         en: "Turkish",       sq: "Turqisht",       region: "europe" },
  uk:  { code: "uk",  native: "Українська",     en: "Ukrainian",     sq: "Ukrainisht",     region: "europe" },
  cy:  { code: "cy",  native: "Cymraeg",        en: "Welsh",         sq: "Uellsisht",      region: "europe" },

  // --- Lindja e Mesme & Azia ----------------------------------------------
  ar:  { code: "ar",  native: "العربية",        en: "Arabic",        sq: "Arabisht",       region: "mena_asia", dir: "rtl" },
  he:  { code: "he",  native: "עברית",          en: "Hebrew",        sq: "Hebraisht",      region: "mena_asia", dir: "rtl", aliases: ["iw"] },
  fa:  { code: "fa",  native: "فارسی",          en: "Persian",       sq: "Persisht",       region: "mena_asia", dir: "rtl" },
  ur:  { code: "ur",  native: "اردو",           en: "Urdu",          sq: "Urdu",           region: "mena_asia", dir: "rtl" },
  hi:  { code: "hi",  native: "हिन्दी",           en: "Hindi",         sq: "Hindi",          region: "mena_asia" },
  bn:  { code: "bn",  native: "বাংলা",           en: "Bengali",       sq: "Bengali",        region: "mena_asia" },
  ps:  { code: "ps",  native: "پښتو",           en: "Pashto",        sq: "Pashto",         region: "mena_asia", dir: "rtl" },
  // Kurdishtja këtu = Kurmanji (shkrim latin, nga e majta). Soranishtja (ckb,
  // nga e djathta) do të ishte hyrje e veçantë nëse duhet më vonë.
  ku:  { code: "ku",  native: "Kurdî",          en: "Kurdish",       sq: "Kurdisht",       region: "mena_asia" },
  hy:  { code: "hy",  native: "Հայերեն",        en: "Armenian",      sq: "Armenisht",      region: "mena_asia" },
  ka:  { code: "ka",  native: "ქართული",        en: "Georgian",      sq: "Gjeorgjisht",    region: "mena_asia" },
  az:  { code: "az",  native: "Azərbaycan",     en: "Azerbaijani",   sq: "Azerbajxhanisht",region: "mena_asia" },
  kk:  { code: "kk",  native: "Қазақша",        en: "Kazakh",        sq: "Kazakisht",      region: "mena_asia" },
  uz:  { code: "uz",  native: "Oʻzbekcha",      en: "Uzbek",         sq: "Uzbekisht",      region: "mena_asia" },

  // --- Azia Lindore & Juglindore ------------------------------------------
  "zh-Hans": { code: "zh-Hans", native: "简体中文", en: "Chinese (Simplified)",  sq: "Kinezisht (e thjeshtuar)", region: "east_asia", aliases: ["zh", "zh-cn", "zh-sg", "zh-hans"] },
  "zh-Hant": { code: "zh-Hant", native: "繁體中文", en: "Chinese (Traditional)", sq: "Kinezisht (tradicionale)", region: "east_asia", aliases: ["zh-tw", "zh-hk", "zh-mo", "zh-hant"] },
  ja:  { code: "ja",  native: "日本語",           en: "Japanese",    sq: "Japonisht",      region: "east_asia" },
  ko:  { code: "ko",  native: "한국어",           en: "Korean",      sq: "Koreançe",       region: "east_asia" },
  vi:  { code: "vi",  native: "Tiếng Việt",     en: "Vietnamese",   sq: "Vietnamisht",    region: "east_asia" },
  th:  { code: "th",  native: "ไทย",             en: "Thai",         sq: "Tajlandisht",    region: "east_asia" },
  id:  { code: "id",  native: "Bahasa Indonesia",en: "Indonesian",   sq: "Indonezisht",    region: "east_asia", aliases: ["in"] },
  ms:  { code: "ms",  native: "Bahasa Melayu",  en: "Malay",         sq: "Malajisht",      region: "east_asia" },
  fil: { code: "fil", native: "Filipino",       en: "Filipino",      sq: "Filipinisht",    region: "east_asia", aliases: ["tl"] },

  // --- Afrikë --------------------------------------------------------------
  sw:  { code: "sw",  native: "Kiswahili",      en: "Swahili",       sq: "Suahilisht",     region: "africa" },
  af:  { code: "af",  native: "Afrikaans",      en: "Afrikaans",     sq: "Afrikaans",      region: "africa" },
  am:  { code: "am",  native: "አማርኛ",           en: "Amharic",       sq: "Amharisht",      region: "africa" },
  so:  { code: "so",  native: "Soomaali",       en: "Somali",        sq: "Somali",         region: "africa" },
  ha:  { code: "ha",  native: "Hausa",          en: "Hausa",         sq: "Hausa",          region: "africa" },
  yo:  { code: "yo",  native: "Yorùbá",         en: "Yoruba",        sq: "Jorubisht",      region: "africa" },
  ig:  { code: "ig",  native: "Igbo",           en: "Igbo",          sq: "Igbo",           region: "africa" },
  zu:  { code: "zu",  native: "isiZulu",        en: "Zulu",          sq: "Zulu",           region: "africa" },
  st:  { code: "st",  native: "Sesotho",        en: "Sesotho",       sq: "Sesoto",         region: "africa" },
  sn:  { code: "sn",  native: "ChiShona",       en: "Shona",         sq: "Shona",          region: "africa" },

  // --- Amerika (anglishtja/spanjishtja/portugalishtja/frëngjishtja janë më lart) ---
  ht:  { code: "ht",  native: "Kreyòl Ayisyen", en: "Haitian Creole",sq: "Haitisht",       region: "americas" },

  // --- Oqeani --------------------------------------------------------------
  mi:  { code: "mi",  native: "Te Reo Māori",   en: "Māori",         sq: "Maori",          region: "oceania" },
  haw: { code: "haw", native: "ʻŌlelo Hawaiʻi", en: "Hawaiian",      sq: "Havajisht",      region: "oceania" },
};

export const LANG_CODES = Object.keys(LANGUAGES);

// Gjuha burim dhe gjuha pivot — të dyja gjithmonë të pranishme në build.
export const SOURCE_LANG = "sq";
export const PIVOT_LANG = "en";

// ============================================================================
// GJUHËT QË OFROJMË VËRTET — 29 gusht 2026
//
// «A t'i bëjmë vetëm 29 gjuhët e DeepL-it të përkthyeshme? Nëse gjuha e
//  sistemit nuk është një nga këto, duhet me patjetër të përdorë shqip ose
//  anglisht.»
//
// Regjistri lart ka 72 gjuhë. Ai MBETET i tërë, dhe me qëllim: `normalizeLang`
// duhet ta njohë ende një telefon havajisht për ta kthyer te `haw` — dhe pastaj
// për ta refuzuar me vetëdije. Një kod që s'e njohim fare nuk dallohet dot nga
// një kod që e njohim dhe s'e mbulojmë, dhe dallimi ka rëndësi kur dikush pyet
// pse aplikacioni i doli anglisht.
//
// Ajo që ngushtohet është lista e gjuhëve që OFROHEN. Kufiri u zgjodh të jetë
// mbulimi i DeepL-it, sepse ai është motori i parë te `scripts/translate.mjs`;
// pas tij vjen Google (me pagesë) dhe MyMemory (~5.000 shenja/ditë). Pra një
// gjuhë jashtë kësaj liste do të thoshte ose faturë, ose një skedar që mbushet
// me pika-pika për javë të tëra — dhe gjysma e ndërfaqes në anglisht, që është
// pikërisht ankesa nga e cila nisi gjithë kjo punë.
//
// ─────────────────────────────────────────────────────────────────────────────
// TABELA U TREFISHUA — 29 gusht, po atë ditë
//
// «Po për shembull danishtja nuk është, si gjuhë boshnjisht. Nëse janë të
//  mbështetura nga DeepL edhe nuk na prishin punë, t'i shtojmë të gjitha.»
//
// Kishte të drejtë, dhe tabela e vjetër ishte thjesht e vjetruar: 30 kode, të
// shkruara kur DeepL-i mbulonte pak. Sot ai mbulon **66 nga 72** gjuhët e
// regjistrit tonë — përfshirë boshnjishten, kroatishten, serbishten dhe
// maqedonishten, që për një platformë familjesh shqiptare peshojnë më shumë se
// japonishtja.
//
// Jashtë mbeten gjashtë: malazezishtja, amharishtja, somalishtja, jorubishtja,
// shona, havajishtja. Malazezishtja është e vetmja që bën përshtypje —
// telefonat `sr-ME` normalizohen te `cnr` dhe do të biejnë te parazgjedhja.
// Kur të duhet, aliasi mund ta çojë te `sr`; sot askush s'e ka kërkuar.
//
// KUJDES ME KUPTIMIN: kjo tabelë thotë çfarë LEJOHET, jo çfarë ekziston.
// Zgjerimi i saj nuk krijoi asnjë skedar dhe nuk shpenzoi asnjë shenjë kuote.
// Gjuha del te zgjedhësi vetëm kur `locales/<kod>.json` ekziston vërtet — dhe
// ai lind me një komandë: `node scripts/translate.mjs --app=main --lang=da`.
// Ndarja është me qëllim: lejimi është falas, gjenerimi paguhet me kuotë.
//
// KY ËSHTË BURIMI I VETËM. `scripts/translate.mjs` e importon këtë tabelë në
// vend të kopjes së vet; kështu shtimi i një gjuhe është një rresht, jo dy
// rreshta në dy skedarë që nesër nuk përputhen.
//
// VLERAT janë kodet e DeepL-it (jo tonat): norvegjishtja te ne `no`, te DeepL
// `NB`; portugalishtja `PT-PT` që të mos kthehet braziliançe.
//
// PËR TA RIPARË: DeepL-i i ka shtuar gjuhë kohët e fundit (shqipja u shtua —
// prandaj kjo listë s'është më aq e vogël sa dukej). Lista e vërtetë merret nga
// vetë ai: `node scripts/gjuhet-deepl.mjs`. Mos e zgjero këtë tabelë nga
// kujtesa ose nga një faqe dokumentacioni — pyet API-n.
// ============================================================================
export const DEEPL_TARGET = {
  // ── Evropë ──────────────────────────────────────────────────
  "bs":       "BS",       // Boshnjakisht
  "bg":       "BG",       // Bullgarisht
  "cs":       "CS",       // Çekisht
  "da":       "DA",       // Danisht
  "et":       "ET",       // Estonisht
  "fi":       "FI",       // Finlandisht
  "fr":       "FR",       // Frëngjisht
  "de":       "DE",       // Gjermanisht
  "el":       "EL",       // Greqisht
  "nl":       "NL",       // Holandisht
  "hu":       "HU",       // Hungarisht
  "is":       "IS",       // Islandisht
  "ga":       "GA",       // Irlandisht
  "it":       "IT",       // Italisht
  "ca":       "CA",       // Katalanisht
  "hr":       "HR",       // Kroatisht
  "lv":       "LV",       // Letonisht
  "lt":       "LT",       // Lituanisht
  "lb":       "LB",       // Luksemburgisht
  "mk":       "MK",       // Maqedonisht
  "mt":       "MT",       // Maltisht
  "no":       "NB",       // Norvegjisht
  "pl":       "PL",       // Polonisht
  "pt":       "PT-PT",    // Portugalisht
  "ro":       "RO",       // Rumanisht
  "ru":       "RU",       // Rusisht
  "sr":       "SR",       // Serbisht
  "sk":       "SK",       // Sllovakisht
  "sl":       "SL",       // Sllovenisht
  "es":       "ES",       // Spanjisht
  "sv":       "SV",       // Suedisht
  "tr":       "TR",       // Turqisht
  "uk":       "UK",       // Ukrainisht
  "cy":       "CY",       // Uellsisht
  // ── Lindja e Mesme & Azia ───────────────────────────────────
  "ar":       "AR",       // Arabisht
  "he":       "HE",       // Hebraisht
  "fa":       "FA",       // Persisht
  "ur":       "UR",       // Urdu
  "hi":       "HI",       // Hindi
  "bn":       "BN",       // Bengali
  "ps":       "PS",       // Pashto
  "ku":       "KMR",      // Kurdisht
  "hy":       "HY",       // Armenisht
  "ka":       "KA",       // Gjeorgjisht
  "az":       "AZ",       // Azerbajxhanisht
  "kk":       "KK",       // Kazakisht
  "uz":       "UZ",       // Uzbekisht
  // ── Azia Lindore & Juglindore ───────────────────────────────
  "zh-Hans":  "ZH",       // Kinezisht (e thjeshtuar)
  "zh-Hant":  "ZH-HANT",  // Kinezisht (tradicionale)
  "ja":       "JA",       // Japonisht
  "ko":       "KO",       // Koreançe
  "vi":       "VI",       // Vietnamisht
  "th":       "TH",       // Tajlandisht
  "id":       "ID",       // Indonezisht
  "ms":       "MS",       // Malajisht
  "fil":      "TL",       // Filipinisht
  // ── Afrikë ──────────────────────────────────────────────────
  "sw":       "SW",       // Suahilisht
  "af":       "AF",       // Afrikaans
  "ha":       "HA",       // Hausa
  "ig":       "IG",       // Igbo
  "zu":       "ZU",       // Zulu
  "st":       "ST",       // Sesoto
  // ── Amerika ─────────────────────────────────────────────────
  "ht":       "HT",       // Haitisht
  // ── Oqeani ──────────────────────────────────────────────────
  "mi":       "MI",       // Maori
};

// Gjuhët e ofrueshme = ato që përkthehen mirë + burimi + pivoti. Shqipja dhe
// anglishtja nuk kalojnë kurrë nga një motor: `sq.json` shkruhet me dorë dhe
// `en.json` është vetë katalogu. Të dyja janë të bundle-uara statikisht, pra
// janë e vetmja rezervë që nuk dështon dot.
export const SUPPORTED_LANGS = Object.freeze(
  new Set([SOURCE_LANG, PIVOT_LANG, ...Object.keys(DEEPL_TARGET)])
);

export function isSupportedLang(code) {
  return !!code && SUPPORTED_LANGS.has(code);
}

// Harta alias → kod kanonik, e ndërtuar një herë.
const ALIAS_TO_CODE = (() => {
  const m = {};
  for (const code of LANG_CODES) {
    m[code.toLowerCase()] = code;
    for (const a of LANGUAGES[code].aliases || []) m[a.toLowerCase()] = code;
  }
  return m;
})();

// Normalizon një etiketë BCP-47 ("nb-NO", "zh-TW", "sr-ME", "en_US") në kodin
// tonë. Provon fillimisht etiketën e plotë (që "zh-TW" të mos bëhet thjesht
// "zh"), pastaj bazën para "-".
export function normalizeLang(tag) {
  if (!tag) return null;
  const t = String(tag).toLowerCase().replace(/_/g, "-");
  if (ALIAS_TO_CODE[t]) return ALIAS_TO_CODE[t];
  const parts = t.split("-");
  // "zh-hans-cn" → provo "zh-hans"
  if (parts.length > 2) {
    const two = parts.slice(0, 2).join("-");
    if (ALIAS_TO_CODE[two]) return ALIAS_TO_CODE[two];
  }
  return ALIAS_TO_CODE[parts[0]] || null;
}

// Emri për shfaqje. `inLang`: "native" (parazgjedhje), "sq" ose "en".
export function langLabel(code, inLang = "native") {
  const L = LANGUAGES[code];
  if (!L) return code;
  return L[inLang] || L.native;
}

// Etiketë me kod, si te Admin Center: "Shqip — sq", "العربية — ar".
export function langLabelWithCode(code, inLang = "native") {
  if (!LANGUAGES[code]) return code;
  return `${langLabel(code, inLang)} — ${code}`;
}

// Drejtimi i shkrimit: "rtl" për arabisht/hebraisht/persisht/urdu/pashto.
export function langDir(code) {
  return (LANGUAGES[code] && LANGUAGES[code].dir) || "ltr";
}

// Gjuhët e grupuara sipas rajonit — për listën në Admin Center.
//
// Kthen VETËM gjuhët e ofrueshme (shih `SUPPORTED_LANGS`). Të tjerat mbeten te
// regjistri për njohjen e kodeve, por nuk kanë pse t'i dalin askujt përpara:
// një kuti që shënohet dhe nuk prodhon përkthim është një premtim i rremë.
// `gjitha = true` e kthen listën e plotë, nëse ndonjëherë duhet një pamje
// diagnostikuese.
export function languagesByRegion(gjitha = false) {
  return REGION_ORDER.map((key) => ({
    region: REGIONS[key],
    languages: LANG_CODES
      .filter((c) => LANGUAGES[c].region === key && (gjitha || SUPPORTED_LANGS.has(c)))
      .map((c) => LANGUAGES[c]),
  })).filter((g) => g.languages.length);
}

// Konfigurimi parazgjedhës — vlen derisa (ose nëse) serveri kthen diçka tjetër.
// I shkruar kështu që aplikacioni të punojë plotësisht edhe PA server.
export const DEFAULT_LANG_CONFIG = {
  primary: "sq",
  available: ["sq", "en"],
  allowSystem: true,
};

// Pastron çfarëdo konfigurimi (nga serveri ose nga cache) në formë të sigurt:
// heq kodet e panjohura, garanton që primarja është gjithmonë e disponueshme.
// Filtri tani është `SUPPORTED_LANGS`, jo `LANGUAGES`. Kjo e pastron VETË çdo
// konfigurim të vjetër: nëse te serveri ka mbetur `haw` ose `sw` nga koha kur
// lista ishte 72 gjuhë, ai bie këtu në heshtje dhe askush nuk sheh një gjuhë që
// s'do të përkthehej kurrë. Pastrimi bëhet në një vend sepse ÇDO rrugë tjetër —
// nisja, zgjedhësi, zgjidhja e gjuhës — kalon nga ky funksion.
export function sanitizeLangConfig(raw) {
  const cfg = raw && typeof raw === "object" ? raw : {};
  const primary = isSupportedLang(cfg.primary) ? cfg.primary : DEFAULT_LANG_CONFIG.primary;
  let available = Array.isArray(cfg.available)
    ? cfg.available.filter((c) => isSupportedLang(c))
    : [...DEFAULT_LANG_CONFIG.available];
  if (!available.includes(primary)) available = [primary, ...available];
  if (!available.length) available = [primary];
  return { primary, available, allowSystem: cfg.allowSystem !== false };
}

// ---------------------------------------------------------------------------
// ZGJIDHJA E GJUHËS — logjika qendrore, e njëjtë në aplikacion dhe në Admin.
//   1) Zgjedhja EKSPLICITE e përdoruesit, nëse atë gjuhë e kemi.
//   2) "system" (ose asnjë zgjedhje ende) → gjuha e telefonit, nëse e kemi.
//   3) Ndryshe → gjuha primare e caktuar nga admini.
//
// ─────────────────────────────────────────────────────────────────────────────
// 29 GUSHT — DY LISTA TË NDRYSHME, JO NJË
//
// «Une e kam telefonin ne norvegjisht edhe gjuha e paisjes nuk po e identifikon
//  nese nuk eshte edhe `no` checked.»
//
// Kishte të drejtë, dhe shkaku ishte pikërisht një rresht: gjuha e telefonit
// pranohej vetëm nëse ndodhej te `available`. Pra «Gjuha e pajisjes» ishte një
// premtim që s'mbahej derisa dikush te Admin Center-i të shënonte kutinë e
// duhur — dhe për ta mbajtur për të gjithë, do të duheshin 72 kuti.
//
// Gabimi ishte se një listë përdorej për dy punë. `available` NUK është lista e
// gjuhëve që dimë; është lista e gjuhëve që SHFAQEN te zgjedhësi me dorë — të
// preferuarat, ato pak që duam t'i shohë njeriu përballë shqipes dhe anglishtes.
// Zbulimi automatik s'ka pse të kufizohet prej saj. Kufiri i tij i vërtetë është
// një i vetëm: a EKZISTON një skedar përkthimi për atë gjuhë.
//
// Prandaj `hasTranslations` vjen nga JASHTË. Ky skedar s'mund ta dijë vetë —
// skedarët i njeh `i18n.js`, dhe ai e importon këtë; importi i kundërt do të
// bënte rreth. Pa atë argument, sjellja e vjetër mbetet fjalë për fjalë, pra
// Admin Center-i (që e thërret pa të) nuk ndryshon aspak.
//
// KUJDES, dega e parë e përdor po atë provë. Nuk është zbukurim: në vizitën e
// parë `i18n` e shkruan gjuhën e zgjidhur te `localStorage`, kështu që herën e
// dytë norvegjishtja vjen si zgjedhje EKSPLICITE. Po ta gjykonim atë me listën e
// të preferuarave, telefoni do të fliste norvegjisht një herë dhe shqip përgjithmonë.
// ---------------------------------------------------------------------------

// Provë e vetme, e ndarë që të tri vendet ta përdorin identike.
//
// `isSupportedLang` është KUSHTI I PARË dhe i pakalueshëm: një gjuhë jashtë
// listës së ofrueshme nuk arrihet dot as nga pajisja, as nga një zgjedhje e
// ruajtur nga dikur, as nga një konfigurim i vjetër serveri. Kur telefoni flet
// një gjuhë që s'e mbulojmë, `resolveLanguage` bie te `cfg.primary` — pra te
// shqipja ose anglishtja, siç u kërkua.
function gjuhetQeKemi(cfg, hasTranslations) {
  if (typeof hasTranslations !== "function") {
    return (c) => isSupportedLang(c) && cfg.available.includes(c);
  }
  return (c) => isSupportedLang(c) && (cfg.available.includes(c) || hasTranslations(c));
}

export function resolveLanguage({ stored, config, navigatorLanguages, hasTranslations } = {}) {
  const cfg = sanitizeLangConfig(config);
  const eKemi = gjuhetQeKemi(cfg, hasTranslations);

  if (stored && stored !== "system") {
    const s = normalizeLang(stored);
    if (s && eKemi(s)) return s;
  }

  // RREGULLIM: më parë kjo ishte `cfg.allowSystem || !stored`, pra gjuha e
  // pajisjes përdorej edhe kur admini e kishte ÇAKTIVIZUAR opsionin — thjesht
  // sepse përdoruesi s'kishte zgjedhur ende asgjë. Kështu çelësi në panel nuk
  // ndryshonte asgjë. Tani kuptimi është i qartë dhe i vetëm:
  //   allowSystem = true  → ndiqet gjuha e pajisjes (dhe rezerva është primarja)
  //   allowSystem = false → përdoret gjithmonë primarja, derisa ta ndërrojë vetë
  const wantsSystem = stored === "system" || !stored;
  if (wantsSystem && cfg.allowSystem) {
    for (const tag of navigatorLanguages || []) {
      const c = normalizeLang(tag);
      if (c && eKemi(c)) return c;
    }
  }

  return cfg.primary;
}

// Cilën gjuhë jep vetë pajisja — pa e zbatuar, vetëm për ta THËNË me emër te
// zgjedhësi: «Sistemi · Norsk». Një njeri që e sheh emrin e gjuhës së vet e di
// se zbulimi punoi; pa të, «Sistemi» mbetet premtim i heshtur, dhe kur nuk
// punon, hesht po njësoj. Kthen `null` kur asnjë gjuhë e telefonit s'gjendet.
export function systemLanguage({ config, navigatorLanguages, hasTranslations } = {}) {
  const cfg = sanitizeLangConfig(config);
  const eKemi = gjuhetQeKemi(cfg, hasTranslations);
  for (const tag of navigatorLanguages || []) {
    const c = normalizeLang(tag);
    if (c && eKemi(c)) return c;
  }
  return null;
}

// Opsionet për switch-in e përdoruesit.
//
// `sistemi` (opsional) = kodi që doli nga pajisja, për etiketën e rreshtit të
// parë. Fusha `label` mbetet "System" siç ishte, që asgjë ekzistuese të mos
// prishet; emri i gjuhës vjen veçmas te `sistemiLabel`.
//
// ─────────────────────────────────────────────────────────────────────────────
// `teTjerat` — GJUHËT QË EKZISTOJNË POR S'JANË TË PREFERUARA (29 gusht 2026)
//
// «Përkthimi nuk po funksionon nëse nuk i zgjedh gjuhët këtu. Kur i zgjedh,
//  shfaqen në aplikacion. Ta bëjmë të paktën të fshehen në aplikacion dhe të
//  shfaqen vetëm kur klikon shfaq të tjera.»
//
// Kishte të drejtë, dhe shkaku ishte një kufizim që s'kishte më arsye. Zgjedhësi
// tregonte VETËM `cfg.available` — pra për të zgjedhur norvegjishten me dorë,
// dikush duhej të hynte te Admin Center-i dhe ta shënonte. Kurse skedari i
// norvegjishtes ishte aty, i plotë, i papërdorshëm.
//
// Dallimi që mungonte: `available` nuk është LEJA, është RENDI. Ato janë gjuhët
// që duam t'i shohë njeriu i pari — të preferuarat. Çdo gjuhë me skedar mund të
// zgjidhet; thjesht rri poshtë, pas një kliku.
//
// Kështu Admin Center-i vendos se çfarë PROMOVOHET, jo se çfarë është e mundur —
// dhe një familje norvegjeze s'ka nevojë të presë që dikush t'i shënojë kutinë.
//
// `iPreferuar: true|false` e ndan listën; ndarjen e vizaton klienti.
// ─────────────────────────────────────────────────────────────────────────────
export function switcherOptions(config, labelIn = "native", sistemi = null, teTjerat = null) {
  const cfg = sanitizeLangConfig(config);
  const bej = (code, iPreferuar) => ({
    value: code,
    code,
    label: langLabel(code, labelIn),
    dir: langDir(code),
    iPreferuar,
  });
  const opts = cfg.available.map((code) => bej(code, true));

  if (Array.isArray(teTjerat)) {
    const shtesa = teTjerat
      .filter((c) => isSupportedLang(c) && !cfg.available.includes(c))
      .map((c) => bej(c, false))
      // Renditur sipas emrit që sheh njeriu, jo sipas kodit: dikush kërkon
      // «Deutsch», jo «de», dhe një listë e gjatë pa rend është një listë e
      // pakërkueshme.
      .sort((a, b) => a.label.localeCompare(b.label));
    opts.push(...shtesa);
  }
  if (cfg.allowSystem) {
    const njohur = sistemi && LANGUAGES[sistemi] ? sistemi : null;
    opts.unshift({
      value: "system",
      code: njohur,
      label: "System",
      sistemi: njohur,
      sistemiLabel: njohur ? langLabel(njohur, labelIn) : null,
      dir: njohur ? langDir(njohur) : "ltr",
    });
  }
  return opts;
}

// Etiketat e shfletuesit, në rend prioriteti (i sigurt edhe pa `navigator`).
export function browserLanguages() {
  try {
    const nav = typeof navigator !== "undefined" ? navigator : null;
    if (!nav) return [];
    if (nav.languages && nav.languages.length) return Array.from(nav.languages);
    return nav.language ? [nav.language] : [];
  } catch (e) {
    return [];
  }
}
